import React, { SVGProps } from 'react';
const ChevronDown: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 412 232">
            <path
                d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                fill="CurrentColor"
                fillRule="nonzero"
            />
        </svg>
    );
};

const ArrowDown: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            width="14"
            height="17"
            viewBox="0 0 14 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M6.57128 16.2803C6.24531 16.2803 5.91936 16.1108 5.58035 15.7848L0.325691 10.0347C0.156186 9.86519 -0.000280797 9.53923 -0.000280775 9.04375C-0.000280739 8.2223 0.495169 7.72682 1.31662 7.57035C1.64259 7.57035 1.96857 7.73986 2.30758 8.06583L5.26739 11.3516L5.26739 1.32473C5.26739 0.672787 5.91935 0.00781218 6.58433 0.00781221C7.23628 0.00781224 7.90127 0.659749 7.90127 1.32473L7.90127 11.3516L10.8611 8.06583C11.1871 7.89633 11.513 7.73986 11.852 7.73986C12.6735 7.73986 13.1689 8.3918 13.1689 9.05678C13.1689 9.38275 12.9994 9.87823 12.843 10.0477L7.58831 15.7979C7.22322 16.1108 6.89725 16.2803 6.57128 16.2803Z"
                fill="white"
            />
        </svg>
    );
};

const ArrowRising: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className, ...rest }) => {
    return (
        <svg
            width="27"
            height="33"
            viewBox="0 0 27 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...rest}
        >
            <path
                d="M23.4709 1.70582C23.3084 0.893482 22.5182 0.366656 21.7058 0.529124L8.46799 3.17669C7.65565 3.33916 7.12883 4.1294 7.29129 4.94174C7.45376 5.75408 8.244 6.2809 9.05634 6.11843L20.8233 3.76504L23.1767 15.532C23.3392 16.3443 24.1294 16.8712 24.9417 16.7087C25.7541 16.5462 26.2809 15.756 26.1184 14.9437L23.4709 1.70582ZM3.24808 32.8321L23.2481 2.83205L20.7519 1.16794L0.751925 31.1679L3.24808 32.8321Z"
                fill="currentColor"
            />
        </svg>
    );
};

const ArrowLeft: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className, ...rest }) => {
    return (
        <svg
            width="17"
            height="14"
            viewBox="0 0 17 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...rest}
        >
            <path
                d="M0.101215 6.69703C0.101215 6.37106 0.270718 6.04511 0.596689 5.7061L6.34684 0.451439C6.51634 0.281934 6.84231 0.125467 7.33778 0.125467C8.15923 0.125467 8.65471 0.620917 8.81118 1.44237C8.81118 1.76834 8.64167 2.09432 8.3157 2.43333L5.02991 5.39314L15.0568 5.39314C15.7087 5.39314 16.3737 6.0451 16.3737 6.71008C16.3737 7.36202 15.7218 8.02702 15.0568 8.02702L5.02991 8.02702L8.3157 10.9868C8.4852 11.3128 8.64167 11.6388 8.64167 11.9778C8.64167 12.7992 7.98973 13.2947 7.32475 13.2947C6.99878 13.2947 6.5033 13.1252 6.33379 12.9687L0.583647 7.71406C0.270714 7.34897 0.101215 7.023 0.101215 6.69703Z"
                fill="currentColor"
            />
        </svg>
    );
};

const ArrowRight: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className, ...rest }) => {
    return (
        <svg
            width="17"
            height="14"
            viewBox="0 0 17 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...rest}
        >
            <path
                d="M16.3737 6.72312C16.3737 7.04909 16.2042 7.37504 15.8782 7.71405L10.1281 12.9687C9.95857 13.1382 9.63261 13.2947 9.13713 13.2947C8.31568 13.2947 7.8202 12.7992 7.66373 11.9778C7.66373 11.6518 7.83325 11.3258 8.15922 10.9868L11.445 8.02701H1.41811C0.766171 8.02701 0.101196 7.37505 0.101196 6.71007C0.101196 6.05813 0.753133 5.39313 1.41811 5.39313H11.445L8.15922 2.43332C7.98971 2.10735 7.83325 1.78137 7.83325 1.44236C7.83325 0.620908 8.48518 0.125458 9.15016 0.125458C9.47614 0.125458 9.97162 0.294963 10.1411 0.451429L15.8913 5.70609C16.2042 6.07118 16.3737 6.39715 16.3737 6.72312Z"
                fill="currentColor"
            />
        </svg>
    );
};

const Banner: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            width="17"
            height="25"
            viewBox="0 0 17 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M9.09239 17.9443L8.5 17.5088L7.90761 17.9443L1 23.0235V1H16V23.0235L9.09239 17.9443ZM0.681522 23.2576C0.681667 23.2575 0.68181 23.2574 0.681955 23.2573L0.681522 23.2576Z"
                stroke="currentColor"
                strokeWidth="2"
            />
        </svg>
    );
};

const BarsUp: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            width="120"
            height="120"
            viewBox="0 0 120 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <mask id="path-1-inside-1" fill="white">
                <rect x="3" y="75.3386" width="27" height="44" rx="3" />
            </mask>
            <rect
                x="3"
                y="75.3386"
                width="27"
                height="44"
                rx="3"
                stroke="currentColor"
                strokeWidth="12"
                mask="url(#path-1-inside-1)"
            />
            <mask id="path-2-inside-2" fill="white">
                <rect x="41" y="53.3386" width="27" height="66" rx="3" />
            </mask>
            <rect
                x="41"
                y="53.3386"
                width="27"
                height="66"
                rx="3"
                stroke="currentColor"
                strokeWidth="12"
                mask="url(#path-2-inside-2)"
            />
            <mask id="path-3-inside-3" fill="white">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M94.0488 1.73467C93.2485 0.755056 91.7513 0.755059 90.951 1.73468L66.1673 32.0733C65.1003 33.3795 66.0297 35.3386 67.7162 35.3386H78.9999V116.339C78.9999 117.995 80.3431 119.339 81.9999 119.339H103C104.657 119.339 106 117.995 106 116.339V35.3386H117.284C118.97 35.3386 119.899 33.3795 118.832 32.0733L94.0488 1.73467Z"
                />
            </mask>
            <path
                d="M90.951 1.73468L86.3044 -2.06119V-2.06119L90.951 1.73468ZM94.0488 1.73467L98.6955 -2.06119L98.6954 -2.06119L94.0488 1.73467ZM66.1673 32.0733L61.5207 28.2775L61.5207 28.2775L66.1673 32.0733ZM78.9999 35.3386H84.9999V29.3386H78.9999V35.3386ZM106 35.3386V29.3386H99.9999V35.3386H106ZM118.832 32.0733L114.186 35.8692H114.186L118.832 32.0733ZM95.5977 5.53054C93.9972 7.48976 91.0026 7.48978 89.4021 5.53054L98.6954 -2.06119C95.4944 -5.97967 89.5054 -5.97964 86.3044 -2.06119L95.5977 5.53054ZM70.814 35.8692L95.5977 5.53054L86.3044 -2.06119L61.5207 28.2775L70.814 35.8692ZM67.7162 29.3386C71.0893 29.3386 72.9479 33.2569 70.814 35.8692L61.5207 28.2775C57.2528 33.502 60.9701 41.3386 67.7162 41.3386V29.3386ZM78.9999 29.3386H67.7162V41.3386H78.9999V29.3386ZM84.9999 116.339V35.3386H72.9999V116.339H84.9999ZM81.9999 113.339C83.6568 113.339 84.9999 114.682 84.9999 116.339H72.9999C72.9999 121.309 77.0293 125.339 81.9999 125.339V113.339ZM103 113.339H81.9999V125.339H103V113.339ZM99.9999 116.339C99.9999 114.682 101.343 113.339 103 113.339V125.339C107.97 125.339 112 121.309 112 116.339H99.9999ZM99.9999 35.3386V116.339H112V35.3386H99.9999ZM117.284 29.3386H106V41.3386H117.284V29.3386ZM114.186 35.8692C112.052 33.257 113.911 29.3386 117.284 29.3386V41.3386C124.03 41.3386 127.747 33.502 123.479 28.2775L114.186 35.8692ZM89.4021 5.53053L114.186 35.8692L123.479 28.2775L98.6955 -2.06119L89.4021 5.53053Z"
                fill="currentColor"
                mask="url(#path-3-inside-3)"
            />
        </svg>
    );
};

const FamilyThick: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            width="124"
            height="96"
            viewBox="0 0 124 96"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M10.0005 18C10.0005 22.2435 11.6862 26.3131 14.6868 29.3137C17.6874 32.3143 21.757 34 26.0005 34C30.244 34 34.3136 32.3143 37.3142 29.3137C40.3148 26.3131 42.0005 22.2435 42.0005 18C42.0005 13.7565 40.3148 9.68688 37.3142 6.68629C34.3136 3.68571 30.244 2 26.0005 2C21.757 2 17.6874 3.68571 14.6868 6.68629C11.6862 9.68688 10.0005 13.7565 10.0005 18V18Z"
                stroke="currentColor"
                strokeWidth="7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M39.2693 46.0019C35.6532 43.6025 31.4542 42.2285 27.1192 42.0261C22.7842 41.8237 18.4755 42.8005 14.6516 44.8526C10.8277 46.9046 7.6317 49.9551 5.40386 53.6793C3.17602 57.4036 1.99966 61.6622 2 66.0019"
                stroke="currentColor"
                strokeWidth="7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M118 66.0019C118 61.6622 116.824 57.4036 114.596 53.6793C112.368 49.9551 109.172 46.9046 105.348 44.8526C101.524 42.8005 97.2156 41.8237 92.8806 42.0261C88.5456 42.2285 84.3466 43.6025 80.7305 46.0019"
                stroke="currentColor"
                strokeWidth="7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M78 18C78 22.2435 79.6857 26.3131 82.6863 29.3137C85.6869 32.3143 89.7565 34 94 34C98.2435 34 102.313 32.3143 105.314 29.3137C108.314 26.3131 110 22.2435 110 18C110 13.7565 108.314 9.68688 105.314 6.68629C102.313 3.68571 98.2435 2 94 2C89.7565 2 85.6869 3.68571 82.6863 6.68629C79.6857 9.68688 78 13.7565 78 18V18Z"
                stroke="currentColor"
                strokeWidth="7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M78 17.998C78 17.998 78 37.9981 66 37.9981"
                stroke="currentColor"
                strokeWidth="7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M110 17.998C110 17.998 110 37.9981 122 37.9981"
                stroke="currentColor"
                strokeWidth="7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M46 66C46 69.1826 47.2643 72.2348 49.5147 74.4853C51.7652 76.7357 54.8174 78 58 78C61.1826 78 64.2348 76.7357 66.4853 74.4853C68.7357 72.2348 70 69.1826 70 66C70 62.8174 68.7357 59.7652 66.4853 57.5147C64.2348 55.2643 61.1826 54 58 54C54.8174 54 51.7652 55.2643 49.5147 57.5147C47.2643 59.7652 46 62.8174 46 66V66Z"
                stroke="currentColor"
                strokeWidth="7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M78.7844 94.0002C76.6775 90.3533 73.648 87.325 70.0002 85.2196C66.3524 83.1142 62.2148 82.0059 58.003 82.0059C53.7912 82.0059 49.6536 83.1142 46.0059 85.2196C42.3581 87.325 39.3286 90.3533 37.2217 94.0002"
                stroke="currentColor"
                strokeWidth="7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

const FamilyThin: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            width="120"
            height="120"
            viewBox="0 0 120 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M68.09 74.4901C68.23 74.5601 68.36 74.6301 68.5 74.7101V74.1201C68.37 74.2501 68.23 74.3701 68.09 74.4901Z"
                fill="currentColor"
            />
            <path
                d="M49 74.7101C49.13 74.6301 49.27 74.5601 49.41 74.4901C49.27 74.3701 49.14 74.2501 49 74.1201V74.7101Z"
                fill="currentColor"
            />
            <path
                d="M55 77.48V79.5H62.5V77.48C61.3 77.81 60.05 78 58.75 78C57.45 78 56.2 77.81 55 77.48Z"
                fill="currentColor"
            />
            <path
                d="M62.5 71.0901C61.37 71.6701 60.1 72.0001 58.75 72.0001C57.4 72.0001 56.13 71.6701 55 71.0901V73.5001H62.5V71.0901Z"
                fill="currentColor"
            />
            <path
                d="M91.28 32.39C95.65 29.11 98.5 23.89 98.5 18C98.5 8.06 90.44 0 80.5 0C70.56 0 62.5 8.06 62.5 18C62.5 24.13 65.57 29.54 70.26 32.79C65.68 34.95 62.5 39.6 62.5 45V50.02C61.3 49.69 60.05 49.5 58.75 49.5C57.07 49.5 55.47 49.81 53.97 50.34C52.68 47.23 50.27 44.72 47.24 43.3C51.93 40.04 55 34.63 55 28.5C55 18.56 46.94 10.5 37 10.5C27.06 10.5 19 18.56 19 28.5C19 34.91 22.37 40.53 27.42 43.72C23.29 46.03 20.5 50.44 20.5 55.5V96C20.5 103.46 26.54 109.5 34 109.5H41.5C42.53 109.5 43.53 109.37 44.5 109.15V111C44.5 115.97 48.53 120 53.5 120H64C68.97 120 73 115.97 73 111V109.15C73.97 109.37 74.97 109.5 76 109.5H86.5C93.96 109.5 100 103.46 100 96V45C100 39.23 96.37 34.32 91.28 32.39ZM68.5 18C68.5 11.37 73.87 6 80.5 6C87.13 6 92.5 11.37 92.5 18C92.5 24.63 87.13 30 80.5 30C73.87 30 68.5 24.63 68.5 18ZM25 28.5C25 21.87 30.37 16.5 37 16.5C43.63 16.5 49 21.87 49 28.5C49 35.13 43.63 40.5 37 40.5C30.37 40.5 25 35.13 25 28.5ZM49 74.71C46.31 76.27 44.5 79.17 44.5 82.5V102.87C43.58 103.27 42.57 103.5 41.5 103.5H34C29.86 103.5 26.5 100.14 26.5 96V55.5C26.5 51.36 29.86 48 34 48H41.5C44.99 48 47.91 50.38 48.75 53.61C46.13 56.19 44.5 59.78 44.5 63.75C44.5 67.84 46.24 71.52 49 74.12C49.13 74.25 49.27 74.37 49.41 74.49C49.27 74.56 49.13 74.64 49 74.71ZM55 56.41C56.13 55.83 57.4 55.5 58.75 55.5C60.1 55.5 61.37 55.83 62.5 56.41C65.17 57.78 67 60.55 67 63.75C67 66.95 65.17 69.73 62.5 71.09V73.5H55V71.09C52.33 69.72 50.5 66.95 50.5 63.75C50.5 60.55 52.33 57.77 55 56.41ZM67 106.04V111C67 112.66 65.66 114 64 114H53.5C51.84 114 50.5 112.66 50.5 111V106.04V82.5C50.5 80.84 51.84 79.5 53.5 79.5H55V77.48C56.2 77.81 57.45 78 58.75 78C60.05 78 61.3 77.81 62.5 77.48V79.5H64C65.66 79.5 67 80.84 67 82.5V106.04ZM94 96C94 100.14 90.64 103.5 86.5 103.5H76C74.93 103.5 73.92 103.27 73 102.87V82.5C73 79.17 71.19 76.27 68.5 74.71C68.37 74.63 68.23 74.56 68.09 74.49C68.23 74.37 68.36 74.25 68.5 74.12C71.26 71.52 73 67.84 73 63.75C73 59.66 71.26 55.98 68.5 53.38V45C68.5 40.86 71.86 37.5 76 37.5H86.5C90.64 37.5 94 40.86 94 45V96Z"
                fill="currentColor"
            />
        </svg>
    );
};

const Globe: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            width="120"
            height="120"
            viewBox="0 0 120 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M17.0187 47.227C17.0187 57.3603 21.0441 67.0786 28.2094 74.2439C35.3748 81.4092 45.093 85.4347 55.2263 85.4347C65.3596 85.4347 75.0779 81.4092 82.2432 74.2439C89.4085 67.0786 93.434 57.3603 93.434 47.227C93.434 37.0937 89.4085 27.3755 82.2432 20.2102C75.0779 13.0448 65.3596 9.01941 55.2263 9.01941C45.093 9.01941 35.3748 13.0448 28.2094 20.2102C21.0441 27.3755 17.0187 37.0937 17.0187 47.227V47.227Z"
                stroke="currentColor"
                strokeWidth="7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M93.0516 9.40674C103.083 19.4387 108.718 33.0447 108.718 47.2316C108.717 61.4184 103.081 75.024 93.0491 85.0553C83.0171 95.0866 69.4111 100.722 55.2243 100.721C41.0374 100.721 27.4318 95.0847 17.4005 85.0528"
                stroke="currentColor"
                strokeWidth="7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M98.4506 4L93.0505 9.40511"
                stroke="currentColor"
                strokeWidth="7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.4 85.0498L12 90.4549"
                stroke="currentColor"
                strokeWidth="7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M55.226 100.717V116"
                stroke="currentColor"
                strokeWidth="7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M24.6599 116H85.7921"
                stroke="currentColor"
                strokeWidth="7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.1963 31.9436H28.4797C30.5064 31.9436 32.45 32.7487 33.8831 34.1818C35.3161 35.6148 36.1212 37.5585 36.1212 39.5851V47.8838C36.1208 48.8875 36.3181 49.8814 36.7018 50.8088C37.0855 51.7363 37.6482 52.579 38.3577 53.2889L44.2416 59.1729C45.2457 60.176 45.9505 61.439 46.2771 62.8201C46.6037 64.2013 46.5392 65.6462 46.0909 66.9927L44.5167 71.7101C44.0246 73.1834 43.0952 74.4718 41.8524 75.4035L35.6576 80.0496"
                stroke="currentColor"
                strokeWidth="7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M67.4516 11.0238C65.3782 12.6795 63.1673 14.3963 61.2059 15.9093C59.6141 17.1353 58.5691 18.939 58.2974 20.9299C58.0257 22.9207 58.549 24.9385 59.754 26.5463L64.395 32.7054C65.1068 33.6544 66.0298 34.4247 67.0908 34.9552C68.1519 35.4858 69.3219 35.762 70.5082 35.762H74.9862C77.0121 35.7638 78.9545 36.57 80.3862 38.0035L86.2701 43.8875C87.1881 44.8048 88.3246 45.4732 89.5724 45.8297C90.8202 46.1863 92.1382 46.2191 93.4022 45.9252"
                stroke="currentColor"
                strokeWidth="7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

const GrowingBars: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            width="102"
            height="79"
            viewBox="0 0 102 79"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M18.6659 56.5178H2.38583C1.1995 56.5178 0.237793 57.4795 0.237793 58.6659V76.1536C0.237793 77.3399 1.1995 78.3016 2.38583 78.3016H18.6659C19.8522 78.3016 20.8139 77.3399 20.8139 76.1536V58.6659C20.8139 57.4795 19.8522 56.5178 18.6659 56.5178Z"
                fill="currentColor"
            />
            <path
                d="M45.4874 37.7938H29.2037C28.0174 37.7938 27.0557 38.7555 27.0557 39.9419V76.1522C27.0557 77.3385 28.0174 78.3002 29.2037 78.3002H45.4874C46.6737 78.3002 47.6354 77.3385 47.6354 76.1522V39.9419C47.6354 38.7555 46.6737 37.7938 45.4874 37.7938Z"
                fill="currentColor"
            />
            <path
                d="M72.3062 19.0698H56.0238C54.8374 19.0698 53.8757 20.0315 53.8757 21.2179V76.1532C53.8757 77.3395 54.8374 78.3012 56.0238 78.3012H72.3062C73.4925 78.3012 74.4543 77.3395 74.4543 76.1532V21.2179C74.4543 20.0315 73.4926 19.0698 72.3062 19.0698Z"
                fill="currentColor"
            />
            <path
                d="M99.1299 0.3479H82.8438C81.6575 0.3479 80.6958 1.30961 80.6958 2.49593V76.1538C80.6958 77.3401 81.6575 78.3019 82.8438 78.3019H99.1299C100.316 78.3019 101.278 77.3402 101.278 76.1538V2.49594C101.278 1.30961 100.316 0.3479 99.1299 0.3479Z"
                fill="currentColor"
            />
        </svg>
    );
};

const House: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            viewBox="0 0 24 24"
            stroke="currentColor"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
            />
        </svg>
    );
};

const HouseOriginal: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            width="120"
            height="120"
            viewBox="0 0 120 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M117.284 50.25L64.2239 9.44C61.7339 7.52 58.2539 7.52 55.7639 9.44L27.3339 31.3V22.26C27.3339 21.16 26.4339 20.26 25.3339 20.26H15.4539C14.3539 20.26 13.4539 21.16 13.4539 22.26V41.97L2.70394 50.25C-0.326059 52.59 -0.896059 56.95 1.43394 59.98C2.79394 61.76 4.85394 62.69 6.93394 62.69C7.69394 62.69 8.45394 62.56 9.19394 62.31L10.1939 61.51V105.18C10.1939 106.89 10.8839 108.56 12.0839 109.76C13.2839 110.96 14.9539 111.64 16.6539 111.64H47.5939V71.94C47.5939 71.82 47.6439 71.69 47.7339 71.6C47.8139 71.52 47.9439 71.47 48.0539 71.47H71.9139C72.0339 71.47 72.1639 71.53 72.2539 71.62C72.3339 71.69 72.3839 71.83 72.3839 71.95V111.65H103.324C105.054 111.65 106.684 110.98 107.914 109.75C109.124 108.52 109.794 106.9 109.794 105.19V61.46L110.904 62.32C113.624 63.2 116.714 62.38 118.554 59.98C120.894 56.95 120.324 52.59 117.284 50.25ZM103.794 105.18C103.794 105.34 103.714 105.46 103.664 105.51C103.574 105.6 103.464 105.64 103.334 105.64H78.3939V71.94C78.3939 70.22 77.7039 68.55 76.4939 67.35C75.2839 66.15 73.6239 65.46 71.9239 65.46H48.0639C46.3539 65.46 44.6839 66.15 43.5039 67.35C42.2939 68.55 41.6039 70.22 41.6039 71.94V105.64H16.6639C16.5439 105.64 16.4039 105.59 16.3239 105.51C16.2439 105.43 16.1939 105.3 16.1939 105.18V56.73L57.8539 23.58C58.7939 22.83 60.1039 22.82 61.0439 23.56L103.794 56.8V105.18Z"
                fill="currentColor"
            />
        </svg>
    );
};

const Coin: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            viewBox="0 0 24 24"
            stroke="currentColor"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M14.121 15.536c-1.171 1.952-3.07 1.952-4.242 0-1.172-1.953-1.172-5.119 0-7.072 1.171-1.952 3.07-1.952 4.242 0M8 10.5h4m-4 3h4m9-1.5a9 9 0 11-18 0 9 9 0 0118 0z"
            />
        </svg>
    );
};

const ErrorIcon: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            viewBox="0 0 24 24"
            stroke="currentColor"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
        </svg>
    );
};

//<IconSVG sizeStyle="h-12 w-12" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />;

const Calendar: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            id="svg-calendar-icon"
        >
            <g clipPath="url(#clip0_4099_2981)">
                <path
                    d="M0.751953 3.75H23.252V23.25H0.751953V3.75Z"
                    stroke="#00B263"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M0.751953 9.75H23.252"
                    stroke="#00B263"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="currentColor"
                />
                <path
                    d="M6.75195 6V0.75"
                    stroke="#00B263"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="currentColor"
                />
                <path
                    d="M17.252 6V0.75"
                    stroke="#00B263"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_4099_2981">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

const Clock: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            viewBox="0 0 24 24"
            stroke="currentColor"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
        </svg>
    );
};

const CustomSecurityShield: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            viewBox="0 0 24 24"
            stroke="currentColor"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
            />
        </svg>
    );
};

const MoneyBag: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            width="120"
            height="120"
            viewBox="0 0 120 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M107.435 55.4253C106.478 46.2157 102.689 37.7564 96.7647 31.6052C93.3407 28.0502 89.3853 25.4035 85.0399 23.7208L90.2805 11.6199V11.1987C90.2805 6.678 86.585 3 82.0431 3H63.3582C58.8165 3 55.1214 6.678 55.1214 11.1987V11.6199L60.5147 24.0746C56.5129 25.7649 52.8593 28.2902 49.6668 31.605C43.7423 37.7561 39.9531 46.2155 38.9965 55.4253C38.7532 57.7673 38.1686 61.1873 37.4136 65.0593H29.13V59.2298C29.13 58.1025 28.2125 57.1891 27.0801 57.1891H4V61.2706H25.0301V103.5H4V107.581H27.0801C28.2125 107.581 29.13 106.668 29.13 105.541V100.471H36.8793L37.7348 101.323H37.5516C37.6629 101.374 37.7785 101.427 37.8928 101.48L53.8933 117.403C54.2776 117.785 54.7988 118 55.3425 118H102.143C107.553 118 111.955 113.618 111.955 108.233C111.955 105.494 110.814 103.016 108.984 101.241C112.567 99.5806 114.746 98.2974 115.004 98.1431C115.775 97.683 116.155 96.7766 115.941 95.9072C115.867 95.6052 108.483 65.5227 107.435 55.4253ZM59.2388 10.818C59.4326 8.72584 61.206 7.0818 63.3582 7.0818H82.0434C84.1956 7.0818 85.9692 8.72584 86.163 10.818L81.1091 22.489C78.5775 21.8735 75.9393 21.5584 73.2161 21.5584C70.1589 21.5584 67.2083 21.9543 64.3963 22.7285L59.2388 10.818ZM102.143 113.919H56.192L39.178 96.9872C38.7937 96.6049 38.2724 96.39 37.7285 96.39H29.1306V69.1411H57.8257L79.3666 90.586C80.4455 91.6611 81.04 93.0896 81.0402 94.6085C81.0408 96.1268 80.4466 97.5537 79.3669 98.6277C78.2878 99.7022 76.8528 100.294 75.3271 100.294C73.8011 100.294 72.3664 99.7022 71.2867 98.6277L58.6553 86.0523L55.756 88.9379L68.3877 101.513C70.2412 103.359 72.7061 104.376 75.3273 104.376C77.4068 104.376 79.3869 103.734 81.0416 102.548H102.144C105.293 102.548 107.855 105.099 107.855 108.234C107.855 111.369 105.293 113.919 102.143 113.919ZM104.459 98.7434C103.715 98.5638 102.941 98.4661 102.143 98.4661H84.3459C84.8655 97.2631 85.1405 95.9568 85.1402 94.6074C85.1396 91.9993 84.1193 89.5463 82.2661 87.7004L77.8751 83.3291C84.2825 82.8279 90.7104 79.019 90.7104 71.5982C90.7104 62.6477 83.3452 61.0328 73.7163 59.8516C68.9145 59.2823 62.3283 58.5017 62.3283 52.8831C62.3283 48.2162 66.4632 45.5396 73.6731 45.5396C77.8431 45.5396 82.1858 47.2873 84.4864 49.7615L88.2838 48.0116C86.1299 44.6876 82.7751 42.8235 77.6367 42.0409L76.2449 41.8292V36.7741H71.7729V41.8746L70.3295 42.0482C67.3464 42.4066 57.6125 44.2479 57.6125 52.8833C57.6125 61.3996 64.4674 62.8406 73.4285 63.8398C76.7722 64.233 85.6286 65.2743 85.6286 71.5988C85.6286 76.4759 81.3393 79.5817 74.366 79.8355L60.125 65.658C59.7407 65.2751 59.2194 65.0602 58.6755 65.0602H41.5915C42.2934 61.3947 42.8365 58.1499 43.0757 55.8457C44.8933 38.3438 57.5696 25.6405 73.2164 25.6405C88.863 25.6405 101.539 38.3436 103.357 55.8454C104.308 65.0095 110.052 89.0296 111.591 95.3679C110.19 96.1168 107.718 97.3679 104.459 98.7434Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="3"
            />
        </svg>
    );
};

const MoneyPig: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            width="120"
            height="120"
            viewBox="0 0 120 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M26.6272 36.6967H29.2295C30.7758 42.5424 35.6786 46.5778 42.1278 46.5778C44.6546 46.5778 46.5781 45.8989 46.5781 45.8989L45.6729 41.4487C45.6729 41.4487 44.0889 41.9767 42.2032 41.9767C38.7335 41.9767 35.8295 39.9024 34.6226 36.6967H42.4295L42.9952 33.8304H33.7929C33.6798 33.0761 33.6421 32.2087 33.7552 31.4921H43.4855L44.0512 28.5881H34.4341C35.6409 25.4201 38.4318 23.4212 42.0146 23.4212C43.5609 23.4212 44.9941 23.7984 44.9941 23.7984L46.1632 19.3858C46.1632 19.3858 44.2775 18.8955 42.1278 18.8955C35.9049 18.8955 30.8512 22.9309 29.2295 28.5881H26.6272V31.4921H28.7015C28.6261 32.2464 28.6261 33.2269 28.7392 33.8304H26.6272V36.6967Z"
                fill="currentColor"
            />
            <path
                d="M116.667 59.7191H107.197C105.75 56.4088 103.777 53.3553 101.353 50.6775C102.397 49.4564 103.312 48.131 104.085 46.7222C105.767 43.5284 106.652 39.9748 106.666 36.3644C106.666 35.4796 106.315 34.6309 105.69 34.0053C105.064 33.3796 104.217 33.0281 103.332 33.0281H101.532C98.3619 33.0298 95.2293 33.7169 92.3486 35.0424C89.468 36.3678 86.9074 38.3003 84.8419 40.7077C82.1674 40.0388 79.4212 39.7007 76.6645 39.7008C75.7804 39.7008 74.9325 40.0523 74.3073 40.678C73.6822 41.3037 73.331 42.1523 73.331 43.0372C73.331 43.9221 73.6822 44.7707 74.3073 45.3964C74.9325 46.0221 75.7804 46.3736 76.6645 46.3736C79.5177 46.3732 82.353 46.8252 85.0649 47.7128C85.75 47.9364 86.4892 47.9315 87.1713 47.6988C87.8534 47.4661 88.4417 47.0182 88.8478 46.4223C90.0723 44.6246 91.6636 43.1072 93.5167 41.97C95.3699 40.8327 97.4429 40.1015 99.599 39.8246C98.8619 43.079 97.0665 45.9966 94.4944 48.1198C94.1272 48.427 93.8304 48.8097 93.6242 49.2419C93.418 49.6741 93.3073 50.1458 93.2996 50.6247C93.2919 51.1036 93.3873 51.5785 93.5795 52.0172C93.7716 52.4558 94.0559 52.8479 94.413 53.1668C97.7555 56.1575 100.293 59.9411 101.793 64.1698C102.023 64.8198 102.448 65.3826 103.011 65.7805C103.574 66.1785 104.246 66.3921 104.935 66.3918H113.333V79.7373H104.933C104.242 79.7369 103.569 79.9511 103.005 80.3503C102.442 80.7496 102.017 81.3142 101.788 81.966C100.471 85.717 98.324 89.1218 95.5081 91.9261C94.3979 93.0481 93.1861 94.0645 91.8882 94.9622C91.2584 95.3912 90.7943 96.0232 90.5734 96.7529C90.3524 97.4827 90.3879 98.2661 90.6738 98.9729L95.0507 109.765H82.1648L78.6112 101.74C78.3497 101.149 77.9226 100.648 77.3818 100.295C76.841 99.9433 76.2097 99.7557 75.5644 99.7556H51.0965C50.4512 99.7557 49.8198 99.9432 49.2789 100.295C48.738 100.648 48.3109 101.149 48.0494 101.74L44.4962 109.765H31.6102L35.9854 98.9736C36.2699 98.2708 36.3069 97.4921 36.0903 96.7656C35.8738 96.039 35.4166 95.4078 34.794 94.9759C31.2563 92.5226 28.3653 89.2477 26.3685 85.4317C24.3717 81.6157 23.3286 77.3723 23.3285 73.0646C23.3168 68.4768 24.5102 63.9666 26.789 59.986C30.4888 61.8024 34.5229 62.8366 38.6396 63.0242C42.7563 63.2117 46.8675 62.5486 50.717 61.0762C54.5665 59.6038 58.0717 57.3536 61.0141 54.4659C63.9566 51.5781 66.2732 48.1148 67.8197 44.2917L67.822 44.278L67.826 44.272C69.4822 40.1649 70.2103 35.742 69.958 31.3203C69.7058 26.8985 68.4795 22.5873 66.3671 18.6956C64.2546 14.8038 61.3083 11.4279 57.7392 8.80965C54.1701 6.19141 50.0665 4.39567 45.7226 3.5511C41.3787 2.70652 36.9018 2.83403 32.6129 3.92447C28.324 5.01491 24.3291 7.04129 20.9145 9.85844C17.5 12.6756 14.7502 16.2137 12.8623 20.2194C10.9744 24.2251 9.99504 28.5991 9.99445 33.0281C9.98817 37.5126 10.9914 41.9409 12.9297 45.9841C14.8679 50.0273 17.6914 53.5815 21.1903 56.3827C18.87 60.3397 17.4073 64.7411 16.8975 69.3008C14.5209 68.715 12.3592 67.4665 10.6631 65.7004C8.967 63.9343 7.80615 61.7229 7.31531 59.323L6.59594 55.7261C6.41545 54.8653 5.90268 54.1107 5.16918 53.6264C4.43567 53.1421 3.54077 52.9673 2.67912 53.1399C1.81748 53.3126 1.0588 53.8188 0.568116 54.5484C0.0774339 55.278 -0.105558 56.172 0.0589458 57.036L0.77865 60.6329C1.57103 64.5386 3.53058 68.111 6.39758 70.8768C9.26457 73.6425 12.9036 75.4709 16.8325 76.1197C17.2316 80.5138 18.4991 84.7847 20.5616 88.6842C22.624 92.5838 25.4402 96.0342 28.8464 98.8351L23.5725 111.847C23.3675 112.353 23.29 112.902 23.3467 113.446C23.4034 113.99 23.5926 114.511 23.8976 114.964C24.2027 115.418 24.6143 115.789 25.0963 116.046C25.5783 116.303 26.1159 116.437 26.662 116.438H46.663C47.3083 116.437 47.9397 116.25 48.4806 115.898C49.0215 115.546 49.4486 115.044 49.7101 114.453L53.265 106.428H73.3976L76.9525 114.453C77.2139 115.044 77.6408 115.545 78.1814 115.897C78.7219 116.249 79.353 116.437 79.998 116.438H99.999C100.545 116.437 101.083 116.303 101.565 116.046C102.047 115.789 102.458 115.418 102.763 114.964C103.068 114.511 103.258 113.99 103.314 113.446C103.371 112.902 103.293 112.353 103.088 111.847L97.8145 98.8401C98.6315 98.1655 99.4315 97.4367 100.215 96.6538C103.169 93.7109 105.54 90.2352 107.203 86.4101H116.667C117.551 86.4101 118.398 86.0586 119.024 85.4329C119.649 84.8072 120 83.9586 120 83.0737V63.0555C120 62.1706 119.649 61.322 119.024 60.6963C118.398 60.0706 117.551 59.7191 116.667 59.7191ZM16.6615 33.0281C16.6659 29.5858 17.4306 26.187 18.9007 23.075C20.3709 19.9631 22.5103 17.2149 25.1656 15.0271C27.821 12.8393 30.9267 11.2661 34.2605 10.42C37.5944 9.57393 41.0739 9.4759 44.45 10.133C47.8261 10.79 51.0153 12.1859 53.7894 14.2207C56.5635 16.2555 58.8539 18.8789 60.4967 21.9032C62.1394 24.9275 63.0939 28.2778 63.2918 31.7144C63.4897 35.151 62.9261 38.5889 61.6414 41.782C59.6093 46.8061 55.895 50.9668 51.1348 53.5512C46.3746 56.1357 40.8646 56.9833 35.5487 55.9487C30.2328 54.9141 25.4416 52.0618 21.9959 47.8802C18.5503 43.6987 16.6644 38.4482 16.6615 33.0281Z"
                fill="currentColor"
            />
            <circle cx="86.25" cy="62.0625" r="4.6875" fill="currentColor" />
        </svg>
    );
};

const MoneyPile: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            width="120"
            height="120"
            viewBox="0 0 120 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M41.8462 40C25.4369 40 8 45.3908 8 55.3846V104.615C8 114.609 25.4369 120 41.8462 120C58.2554 120 75.6923 114.609 75.6923 104.615V55.3846C75.6923 45.3908 58.2554 40 41.8462 40ZM41.8462 113.846C24.9415 113.846 14.1538 108.382 14.1538 104.615V101.409C20.6831 105.538 31.4615 107.692 41.8462 107.692C52.2308 107.692 63.0092 105.538 69.5385 101.409V104.615C69.5385 108.382 58.7508 113.846 41.8462 113.846ZM41.8462 101.538C24.9415 101.538 14.1538 96.0738 14.1538 92.3077V89.1015C20.6831 93.2308 31.4615 95.3846 41.8462 95.3846C52.2308 95.3846 63.0092 93.2308 69.5385 89.1015V92.3077C69.5385 96.0738 58.7508 101.538 41.8462 101.538ZM41.8462 89.2308C24.9415 89.2308 14.1538 83.7662 14.1538 80V76.7938C20.6831 80.9231 31.4615 83.0769 41.8462 83.0769C52.2308 83.0769 63.0092 80.9231 69.5385 76.7938V80C69.5385 83.7662 58.7508 89.2308 41.8462 89.2308ZM41.8462 76.9231C24.9415 76.9231 14.1538 71.4585 14.1538 67.6923V64.4862C20.6831 68.6154 31.4615 70.7692 41.8462 70.7692C52.2308 70.7692 63.0092 68.6154 69.5385 64.4862V67.6923C69.5385 71.4585 58.7508 76.9231 41.8462 76.9231ZM41.8462 64.6154C24.9415 64.6154 14.1538 59.1508 14.1538 55.3846C14.1538 51.6185 24.9415 46.1538 41.8462 46.1538C58.7508 46.1538 69.5385 51.6185 69.5385 55.3846C69.5385 59.1508 58.7508 64.6154 41.8462 64.6154ZM78.7692 0C62.36 0 44.9231 5.39077 44.9231 15.3846V27.6923C44.9231 37.6862 62.36 43.0769 78.7692 43.0769C89.1538 43.0769 99.9323 40.9231 106.462 36.7938V40C106.462 43.7662 95.6739 49.2308 78.7692 49.2308V55.3846C89.1538 55.3846 99.9323 53.2308 106.462 49.1015V52.3077C106.462 56.0738 95.6739 61.5385 78.7692 61.5385V67.6923C89.1538 67.6923 99.9323 65.5385 106.462 61.4092V64.6154C106.462 68.3815 95.6739 73.8462 78.7692 73.8462V80C89.1538 80 99.9323 77.8462 106.462 73.7169V76.9231C106.462 80.6892 95.6739 86.1538 78.7692 86.1538V92.3077C89.1538 92.3077 99.9323 90.1538 106.462 86.0246V89.2308C106.462 92.9969 95.6739 98.4615 78.7692 98.4615V104.615C95.1785 104.615 112.615 99.2246 112.615 89.2308V15.3846C112.615 5.39077 95.1785 0 78.7692 0ZM78.7692 6.15385C95.6739 6.15385 106.462 11.6185 106.462 15.3846C106.462 19.1508 95.6739 24.6154 78.7692 24.6154C61.8646 24.6154 51.0769 19.1508 51.0769 15.3846C51.0769 11.6185 61.8646 6.15385 78.7692 6.15385ZM78.7692 36.9231C61.8646 36.9231 51.0769 31.4585 51.0769 27.6923V24.4862C57.6062 28.6154 68.3846 30.7692 78.7692 30.7692C89.1538 30.7692 99.9323 28.6154 106.462 24.4862V27.6923C106.462 31.4585 95.6739 36.9231 78.7692 36.9231Z"
                fill="currentColor"
            />
        </svg>
    );
};

const Plant: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            width="73"
            height="120"
            viewBox="0 0 73 120"
            fill="none"
            stroke="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <g clipPath="url(#clip0)">
                <path
                    d="M68.0973 63.8496H40.0885H32.1239H3.9823C1.72566 63.8496 0 65.5753 0 67.8319V81.5045C0 83.7611 1.72566 85.4868 3.9823 85.4868H6.10619L13.1416 116.947C13.5398 118.805 15.1327 120 16.9911 120H55.0885C56.9469 120 58.5398 118.673 58.9381 116.947L65.9734 85.4868H68.0973C70.354 85.4868 72.0796 83.7611 72.0796 81.5045V67.8319C72.0796 65.5753 70.354 63.8496 68.0973 63.8496ZM51.9027 112.035H20.3097L14.3363 85.4868H58.0089L51.9027 112.035ZM64.115 77.5222H7.9646V71.8142H64.115V77.5222H64.2478H64.115Z"
                    fill="currentColor"
                />
                <path
                    d="M40.0884 34.5133C54.2919 33.8496 66.2388 21.9027 66.6371 7.56637L66.7698 4.11504C66.7698 3.0531 66.3716 1.99115 65.5751 1.19469C64.7787 0.39823 63.7167 0 62.6548 0L59.2034 0.132743C44.7344 0.530973 32.6548 12.7434 32.1238 27.2124V29.469C27.2123 24.292 20.4424 20.9735 12.876 20.708L9.55743 20.5752C8.49548 20.5752 7.43353 20.9734 6.63707 21.7699C5.84061 22.5664 5.44238 23.6283 5.44238 24.6903L5.57513 28.1416C5.97336 42.4779 17.9203 54.4248 32.1238 55.0885V63.8496H40.0884V34.5133ZM58.6725 8.09734C58.0088 17.7876 49.9114 25.7522 40.2211 26.5487C40.8849 16.8584 48.9822 8.8938 58.6725 8.09734ZM13.5397 28.6726C23.23 29.469 31.1946 37.4336 31.9911 47.1239C22.3008 46.4602 14.3362 38.3628 13.5397 28.6726Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0">
                    <rect width="72.0796" height="120" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

const SecurityShield: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            width="120"
            height="120"
            viewBox="0 0 120 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M59.9979 120C59.0668 120 58.1315 119.726 57.3334 119.169C13.4796 88.8471 10 59.3443 10 23.9186C10 21.6771 11.5918 19.74 13.8014 19.3243C37.6097 14.7729 57.0803 1.01571 57.2733 0.874286C58.9038 -0.291429 61.1005 -0.291429 62.7266 0.874286C62.9197 1.01143 82.3903 14.7729 106.199 19.3243C108.408 19.7443 110 21.6771 110 23.9186C110 59.3443 106.516 88.8471 62.6666 119.169C61.8642 119.726 60.9289 120 59.9979 120ZM19.3834 27.7114C19.6366 59.7857 23.6654 83.5071 59.9979 109.594C96.3303 83.5071 100.359 59.7857 100.612 27.7114C81.6008 23.3271 66.0776 14.2286 59.9979 10.3114C53.9181 14.2286 38.3949 23.3271 19.3834 27.7114Z"
                fill="currentColor"
            />
            <path
                d="M57.2424 77.1426C55.7348 77.1426 54.2401 76.5974 53.0827 75.5112L37.4945 60.8323C35.1541 58.6311 35.1157 55.0239 37.4133 52.7776C39.7067 50.5354 43.4692 50.4944 45.8096 52.6998L57.1997 63.423L79.8603 41.6691C82.1793 39.4433 85.9418 39.4433 88.2608 41.6691C90.5798 43.8949 90.5798 47.5062 88.2608 49.732L61.4405 75.4702C60.2789 76.581 58.7585 77.1426 57.2424 77.1426Z"
                fill="currentColor"
            />
        </svg>
    );
};

const TimeAgenda: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            width="120"
            height="123"
            viewBox="0 0 120 123"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M43.5329 22.217H50.2497C52.058 22.217 53.4789 20.7962 53.4789 18.9878V3.22922C53.4789 1.42086 52.058 0 50.2497 0H43.5329C41.7245 0 40.3037 1.42086 40.3037 3.22922V18.8587C40.1745 20.7962 41.7245 22.217 43.5329 22.217Z"
                fill="currentColor"
            />
            <path
                d="M90.4196 22.217H97.1364C98.9448 22.217 100.366 20.7962 100.366 18.9878V3.22922C100.366 1.42086 98.9448 0 97.1364 0H90.4196C88.6113 0 87.1904 1.42086 87.1904 3.22922V18.8587C87.0612 20.7962 88.6113 22.217 90.4196 22.217Z"
                fill="currentColor"
            />
            <path
                d="M107.727 14.4688H106.048V18.9897C106.048 23.8981 102.043 27.7731 97.2641 27.7731H90.5473C85.6389 27.7731 81.7639 23.7689 81.7639 18.9897V14.4688H59.1593V18.9897C59.1593 23.8981 55.1551 27.7731 50.3758 27.7731H43.6591C38.7506 27.7731 34.8756 23.7689 34.8756 18.9897V14.4688H32.9381C26.0921 14.4688 20.5378 20.023 20.5378 26.869V59.1612C8.52514 64.1987 0 75.9531 0 89.7742C0 107.987 14.7252 122.712 32.9381 122.712C46.6299 122.712 58.3843 114.316 63.4219 102.304H107.598C114.444 102.304 119.998 96.7493 119.998 89.9033V26.869C120.127 20.023 114.444 14.4688 107.727 14.4688ZM33.0672 114.445C19.3753 114.445 8.2668 103.337 8.2668 89.7742C8.2668 76.2115 19.3753 65.1029 32.9381 65.1029C46.5008 65.1029 57.7385 76.0823 57.7385 89.7742C57.7385 103.466 46.6299 114.445 33.0672 114.445ZM111.86 89.9033C111.86 92.0992 109.923 94.0368 107.727 94.0368H65.6178C65.7469 92.6159 65.8761 91.195 65.8761 89.7742C65.8761 71.5614 51.1509 56.8361 32.9381 56.8361C31.5172 56.8361 30.0963 56.9653 28.8046 57.0945V40.3025H111.731V89.9033H111.86Z"
                fill="currentColor"
            />
            <path
                d="M44.8172 85.6397H37.1962V75.8229C37.1962 73.4978 35.3879 71.6895 33.0628 71.6895C30.7378 71.6895 28.9294 73.4978 28.9294 75.8229V89.7731C28.9294 92.0981 30.7378 93.9065 33.0628 93.9065H44.8172C47.1423 93.9065 48.9506 92.0981 48.9506 89.7731C48.9506 87.448 47.1423 85.6397 44.8172 85.6397Z"
                fill="currentColor"
            />
        </svg>
    );
};

const TimeDocument: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            width="120"
            height="120"
            viewBox="0 0 120 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M30.0106 31.0736H62.2211C64.4948 31.0736 66.2632 29.3052 66.2632 27.0315C66.2632 24.7578 64.4948 22.9894 62.2211 22.9894H30.0106C27.7369 22.9894 25.9685 24.7578 25.9685 27.0315C25.9685 29.3052 27.7369 31.0736 30.0106 31.0736Z"
                fill="currentColor"
            />
            <path
                d="M30.0106 50.6528H62.2211C64.4948 50.6528 66.2632 48.8844 66.2632 46.6107C66.2632 44.337 64.4948 42.5686 62.2211 42.5686H30.0106C27.7369 42.5686 25.9685 44.337 25.9685 46.6107C25.9685 48.8844 27.7369 50.6528 30.0106 50.6528Z"
                fill="currentColor"
            />
            <path
                d="M45.8001 61.8948H30.0106C27.7369 61.8948 25.9685 63.6632 25.9685 65.9369C25.9685 68.2106 27.7369 69.979 30.0106 69.979H45.8001C48.0738 69.979 49.8422 68.2106 49.8422 65.9369C49.8422 63.6632 48.0738 61.8948 45.8001 61.8948Z"
                fill="currentColor"
            />
            <path
                d="M87.2316 56.3368V14.2737C87.2316 6.44211 80.7895 0 72.9579 0H19.2737C11.4421 0 5 6.44211 5 14.2737V78.6947C5 86.5263 11.4421 92.9684 19.2737 92.9684H51.6105C54.0105 108.253 67.2737 120 83.1895 120C100.874 120 115.147 105.6 115.147 88.0421C115.147 71.7474 103.021 58.3579 87.2316 56.3368ZM13.0842 78.6947V14.2737C13.0842 10.8632 15.8632 8.21053 19.1474 8.21053H72.8316C76.2421 8.21053 78.8947 10.9895 78.8947 14.2737V56.3368C64.2421 58.2316 52.6211 70.1053 51.1053 84.8842H19.2737C15.8632 84.8842 13.0842 82.1053 13.0842 78.6947ZM83.1895 111.789C70.0526 111.789 59.3158 101.053 59.3158 87.9158C59.3158 74.7789 70.0526 64.0421 83.1895 64.0421C96.3263 64.0421 107.063 74.7789 107.063 87.9158C107.063 101.053 96.3263 111.789 83.1895 111.789Z"
                fill="currentColor"
            />
            <path
                d="M93.2947 83.8738H87.3579V75.2843C87.3579 73.0106 85.5895 71.2422 83.3158 71.2422C81.0421 71.2422 79.2737 73.0106 79.2737 75.2843V87.9159C79.2737 90.1896 81.0421 91.958 83.3158 91.958H93.4211C95.6947 91.958 97.4632 90.1896 97.4632 87.9159C97.3368 85.7685 95.5684 83.8738 93.2947 83.8738Z"
                fill="currentColor"
            />
        </svg>
    );
};

const Tree: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            width="120"
            height="120"
            viewBox="0 0 120 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M105.778 47.8024C104.208 44.7144 101.896 42.0234 99.1084 40.0206L98.879 39.853L98.9319 39.5706C99.1966 38.2031 99.3378 36.8091 99.3378 35.415C99.3378 30.0243 97.3967 24.8364 93.8764 20.8044C90.3561 16.7811 85.5123 14.2137 80.2451 13.5784L79.9892 13.5519L79.8921 13.3137C78.2334 9.35225 75.4895 5.99956 71.9515 3.61738C68.4224 1.25285 64.3109 0 60.0759 0C55.841 0 51.7295 1.25285 48.2004 3.63503C44.6624 6.00838 41.9185 9.36108 40.2598 13.3314L40.1627 13.5696L39.9068 13.5961C34.6396 14.2225 29.8046 16.7899 26.2843 20.822C22.7552 24.8452 20.8141 30.0331 20.8141 35.4239C20.8141 36.8179 20.9553 38.2119 21.2288 39.5794L21.2817 39.8618L21.0523 40.0294C18.2555 42.0322 15.9439 44.7232 14.3822 47.8112C12.8118 50.8992 11.9912 54.3754 12.0001 57.8516C12.0001 63.7188 14.2499 69.242 18.3349 73.3887C22.4199 77.5355 27.846 79.8206 33.6161 79.8206H56.1057L56.9438 115.95C56.9438 117.027 57.3673 118.068 58.1084 118.818C58.8584 119.577 59.8554 120 60.9141 120C61.9729 120 62.9699 119.577 63.7198 118.818C64.4609 118.068 64.8844 117.018 64.8844 115.959L64.0462 79.8206H86.5446C92.3148 79.8206 97.7408 77.5355 101.826 73.3887C105.911 69.242 108.161 63.7188 108.161 57.8516C108.169 54.3578 107.349 50.8904 105.778 47.8024ZM99.7877 60.922C99.1084 63.9659 97.4144 66.7098 95.0234 68.6685C92.6324 70.6183 89.6238 71.7124 86.5446 71.73H64.4874H64.0462V60.0926L79.4422 52.505C80.3597 52.0197 81.0479 51.1992 81.3744 50.2022C81.7008 49.1964 81.6391 48.12 81.1803 47.1583C80.7303 46.2054 79.9363 45.482 78.9657 45.1202C77.9952 44.7585 76.9365 44.8026 75.9836 45.2349L64.0462 51.1198V30.9418C64.0462 29.8566 63.6316 28.842 62.8816 28.0832C62.1317 27.3245 61.1347 26.901 60.0759 26.901C59.0172 26.901 58.0202 27.3245 57.2703 28.0832C56.5291 28.8332 56.1057 29.8743 56.1057 30.9418V55.69L44.1859 49.7699C43.2331 49.2934 42.1567 49.2229 41.1509 49.5669C40.1451 49.911 39.3334 50.6345 38.8657 51.605C38.3981 52.5579 38.3275 53.6872 38.6628 54.7019C39.0069 55.7253 39.7127 56.5547 40.6656 57.0311L56.1057 64.6894V71.7212H33.6073C29.9546 71.7212 26.5225 70.2742 23.9374 67.6539C21.3523 65.0335 19.9318 61.5484 19.9318 57.834C19.9318 55.2224 20.6553 52.6726 22.0317 50.4581C23.4081 48.2523 25.3667 46.4878 27.696 45.3761C28.5871 44.9349 29.2753 44.1762 29.6458 43.2409C30.0164 42.3057 30.0252 41.2646 29.6811 40.3206C28.8871 38.2648 28.5959 36.0062 28.8341 33.8093C29.0723 31.6124 29.8399 29.4684 31.0575 27.6333C32.2751 25.7893 33.9249 24.2629 35.8483 23.2042C37.7629 22.1454 39.9333 21.5631 42.1126 21.5278C42.2184 21.5278 42.3949 21.5455 42.5625 21.5631C42.6949 21.5808 42.8184 21.5896 42.889 21.5896C43.8154 21.6337 44.6977 21.3514 45.4211 20.8044C46.1446 20.2573 46.6563 19.4633 46.8681 18.5633C47.6004 15.59 49.3209 12.9167 51.6942 11.0286C54.0764 9.1405 57.0497 8.10823 60.0671 8.10823C63.0846 8.10823 66.0579 9.14933 68.44 11.0286C70.8222 12.9167 72.5339 15.59 73.2662 18.5633C73.4867 19.4456 74.0073 20.2397 74.7308 20.7867C75.3042 21.219 75.9836 21.4925 76.6983 21.5719L76.6718 21.5455L77.7129 21.5367C79.9186 21.5102 82.1243 22.0572 84.083 23.0895C86.0417 24.1218 87.7357 25.6481 88.9885 27.4921C90.2414 29.3361 91.0354 31.4889 91.3001 33.7122C91.556 35.9356 91.2737 38.2119 90.4708 40.3029C90.1267 41.247 90.1355 42.2792 90.5061 43.2145C90.8766 44.1497 91.5648 44.9085 92.4647 45.3496C95.2263 46.7172 97.4673 49.0288 98.7907 51.8344C100.114 54.6577 100.467 57.8869 99.7877 60.922Z"
                fill="currentColor"
            />
        </svg>
    );
};

const WalkStick: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            width="120"
            height="120"
            viewBox="0 0 120 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M25.8736 34.6048L25.7442 34.5531L25.6111 34.5118C21.8643 33.349 19.6457 29.3303 20.8135 25.4189C24.7829 12.4929 37.058 3.5 50.5146 3.5H91.6357C95.5776 3.5 98.7042 6.65386 98.7042 10.7607C98.7042 14.7845 95.4674 18.0213 91.4436 18.0213H74.1497H70.6497V21.5213V109.239C70.6497 113.263 67.4128 116.5 63.389 116.5C59.3652 116.5 56.1283 113.263 56.1283 109.239V21.5213V18.0213H52.6283H50.5146C43.1618 18.0213 36.866 22.9116 34.6925 29.6737L34.6911 29.678C33.6249 33.0098 30.7616 34.931 27.6482 34.931C27.0819 34.931 26.3763 34.8059 25.8736 34.6048Z"
                stroke="currentColor"
                strokeWidth="7"
            />
        </svg>
    );
};

const Check: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            width="32"
            height="24"
            viewBox="0 0 32 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M11.9598 13.9933L25.6678 0.285279C26.0481 -0.0950929 26.6772 -0.0950929 27.0576 0.285279L30.8906 4.11827C31.2709 4.49864 31.2709 5.12771 30.8906 5.50809C24.8193 11.5794 18.7333 17.6507 12.662 23.7367L12.6327 23.7659L12.5888 23.7952L12.5742 23.8098L12.5303 23.8391L12.4864 23.8683L12.4718 23.883L12.4572 23.8976L12.4425 23.9122L12.4279 23.9268L12.4133 23.9415L12.3987 23.9561L12.384 23.9707L12.3694 23.9854H12.3548L12.3255 24H12.2962H12.2816H12.267H12.2524H12.2377H12.2231H12.2085H12.1938H12.1792H12.1646H12.15H12.0037H11.989H11.9744H11.9451H11.9305H11.9159C11.9013 24 11.872 24 11.8427 23.9854H11.8135H11.7988H11.7696H11.755L11.7111 23.9707L11.6818 23.9561H11.6672L11.6525 23.9415C11.6233 23.9268 11.594 23.9122 11.5648 23.8976L11.5355 23.883L11.4916 23.8537C11.4331 23.8098 11.3746 23.7659 11.3161 23.722C-4.77659 7.62938 16.3779 28.7839 0.285279 12.6913C-0.0950929 12.3109 -0.0950929 11.6818 0.285279 11.3014L4.11826 7.46846C4.49863 7.08809 5.1277 7.08809 5.50807 7.46846L11.9598 13.9933Z"
                fill="currentColor"
            />
        </svg>
    );
};

const Cross: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M17.2276 12C19.8926 9.33496 22.3527 6.87493 23.7145 5.51313C24.0952 5.13241 24.0952 4.50276 23.7145 4.12204L19.878 0.28554C19.4973 -0.09518 18.8676 -0.09518 18.4869 0.28554C18.4869 0.28554 15.5583 3.21417 12 6.77243C9.33496 4.10739 6.87493 1.64735 5.51313 0.28554C5.13241 -0.09518 4.50274 -0.09518 4.12202 0.28554L0.28554 4.12204C-0.09518 4.50276 -0.09518 5.13239 0.28554 5.49847C0.28554 5.49847 3.21414 8.4271 6.77241 11.9854C4.10737 14.6504 1.64735 17.1104 0.28554 18.4722C-0.09518 18.853 -0.09518 19.4826 0.28554 19.8633L4.12202 23.6998C4.50274 24.0805 5.13241 24.0805 5.51313 23.6998C5.51313 23.6998 8.44173 20.7858 12 17.2129C14.665 19.878 17.1251 22.338 18.4869 23.6998C18.8676 24.0805 19.4973 24.0805 19.878 23.6998L23.7145 19.8633C24.0952 19.4826 24.0952 18.853 23.7145 18.4722C23.7145 18.4869 20.7859 15.5583 17.2276 12Z"
                fill="currentColor"
            />
        </svg>
    );
};

const CopySheet: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            width="19"
            height="24"
            viewBox="0 0 19 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M0.814286 2.24568e-06C0.356141 0.00323225 0.00279571 0.45886 0 0.814288V23.0714C5.42857e-05 23.4978 0.387953 23.8857 0.814286 23.8857H18.1857C18.612 23.8857 18.9999 23.4978 19 23.0714V5.7C19 5.48663 18.9131 5.27436 18.7625 5.12322L13.8768 0.237502C13.7256 0.0868919 13.5134 -0.000510754 13.3 2.24568e-06H0.814286ZM1.62857 1.62857H12.4857V5.7C12.4858 6.12635 12.8737 6.51425 13.3 6.51429H17.3714V22.2571H1.62857V1.62857ZM14.1143 2.77366L16.2263 4.88572H14.1143V2.77366ZM3.8 9.22857C3.3503 9.22857 2.98571 9.59313 2.98571 10.0429C2.98571 10.4926 3.3503 10.8571 3.8 10.8571H15.2C15.6497 10.8571 16.0143 10.4926 16.0143 10.0429C16.0143 9.59313 15.6497 9.22857 15.2 9.22857H3.8ZM3.8 13.5714C3.3503 13.5714 2.98571 13.936 2.98571 14.3857C2.98571 14.8354 3.3503 15.2 3.8 15.2H15.2C15.6497 15.2 16.0143 14.8354 16.0143 14.3857C16.0143 13.936 15.6497 13.5714 15.2 13.5714H3.8ZM3.8 17.9143C3.3503 17.9143 2.98571 18.2788 2.98571 18.7286C2.98571 19.1783 3.3503 19.5429 3.8 19.5429H15.2C15.6497 19.5429 16.0143 19.1783 16.0143 18.7286C16.0143 18.2788 15.6497 17.9143 15.2 17.9143H3.8Z"
                fill="currentColor"
            />
        </svg>
    );
};

const Calculator: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M5.354,47.656h36.947c0.345,0,0.625-0.28,0.625-0.625V0.625C42.926,0.28,42.646,0,42.301,0H5.354 C5.009,0,4.729,0.28,4.729,0.625v46.406C4.729,47.376,5.01,47.656,5.354,47.656z M5.979,1.25h35.697v45.156H5.979V1.25z"
                fill="currentColor"
            />
            <path
                d="M39.741,3.842H7.918c-0.345,0-0.625,0.28-0.625,0.625v8.177c0,0.345,0.28,0.625,0.625,0.625h31.823 c0.345,0,0.625-0.28,0.625-0.625V4.467C40.366,4.123,40.085,3.842,39.741,3.842z M39.116,12.02H8.542V5.093h30.573V12.02z"
                fill="currentColor"
            />
            <path
                d="M17.319,15.862h-6.799c-0.345,0-0.625,0.28-0.625,0.625v7.34c0,0.345,0.28,0.625,0.625,0.625h6.799 c0.345,0,0.625-0.28,0.625-0.625v-7.34C17.944,16.143,17.665,15.862,17.319,15.862z M16.694,23.202h-5.549v-6.09h5.549V23.202z"
                fill="currentColor"
            />
            <path
                d="M27.228,15.862h-6.799c-0.345,0-0.625,0.28-0.625,0.625v7.34c0,0.345,0.28,0.625,0.625,0.625h6.799 c0.345,0,0.625-0.28,0.625-0.625v-7.34C27.853,16.142,27.573,15.862,27.228,15.862z M26.603,23.202h-5.549v-6.09h5.549V23.202z"
                fill="currentColor"
            />
            <path
                d="M37.111,15.863h-6.799c-0.345,0-0.625,0.28-0.625,0.625v7.34c0,0.345,0.28,0.625,0.625,0.625h6.799 c0.345,0,0.625-0.28,0.625-0.625v-7.34C37.736,16.143,37.457,15.863,37.111,15.863z M36.486,23.203h-5.549v-6.09h5.549V23.203z"
                fill="currentColor"
            />
            <path
                d="M17.319,25.592h-6.799c-0.345,0-0.625,0.28-0.625,0.625v7.339c0,0.345,0.28,0.625,0.625,0.625h6.799 c0.345,0,0.625-0.28,0.625-0.625v-7.339C17.944,25.872,17.665,25.592,17.319,25.592z M16.694,32.931h-5.549v-6.089h5.549V32.931z"
                fill="currentColor"
            />
            <path
                d="M27.228,25.591h-6.799c-0.345,0-0.625,0.28-0.625,0.625v7.339c0,0.345,0.28,0.625,0.625,0.625h6.799 c0.345,0,0.625-0.28,0.625-0.625v-7.339C27.853,25.872,27.573,25.591,27.228,25.591z M26.603,32.931h-5.549v-6.089h5.549V32.931z"
                fill="currentColor"
            />
            <path
                d="M37.111,25.592h-6.799c-0.345,0-0.625,0.28-0.625,0.625v7.339c0,0.345,0.28,0.625,0.625,0.625h6.799 c0.345,0,0.625-0.28,0.625-0.625v-7.339C37.736,25.873,37.457,25.592,37.111,25.592z M36.486,32.932h-5.549v-6.089h5.549V32.932z"
                fill="currentColor"
            />
            <path
                d="M17.319,35.32h-6.799c-0.345,0-0.625,0.28-0.625,0.625v7.34c0,0.345,0.28,0.625,0.625,0.625h6.799 c0.345,0,0.625-0.28,0.625-0.625v-7.34C17.944,35.6,17.665,35.32,17.319,35.32z M16.694,42.66h-5.549v-6.09h5.549V42.66z"
                fill="currentColor"
            />
            <path
                d="M27.228,35.32h-6.799c-0.345,0-0.625,0.28-0.625,0.625v7.34c0,0.345,0.28,0.625,0.625,0.625h6.799 c0.345,0,0.625-0.28,0.625-0.625v-7.34C27.853,35.6,27.573,35.32,27.228,35.32z M26.603,42.659h-5.549v-6.09h5.549V42.659z"
                fill="currentColor"
            />
            <path
                d="M37.111,35.32h-6.799c-0.345,0-0.625,0.28-0.625,0.625v7.34c0,0.345,0.28,0.625,0.625,0.625h6.799 c0.345,0,0.625-0.28,0.625-0.625v-7.34C37.736,35.601,37.457,35.32,37.111,35.32z M36.486,42.66h-5.549v-6.09h5.549V42.66z"
                fill="currentColor"
            />
        </svg>
    );
};

const DoubleEndedArrow: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            width="512.000000pt"
            height="512.000000pt"
            viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet"
            className={className}
        >
            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                <path
                    d="M688 2957 c-373 -215 -678 -394 -678 -397 0 -3 305 -182 678 -397
l677 -391 3 269 2 269 1190 0 1190 0 2 -269 3 -269 678 391 c372 215 677 394
677 397 0 3 -305 182 -677 397 l-678 391 -3 -269 -2 -269 -1190 0 -1190 0 -2
269 -3 269 -677 -391z"
                    fill="currentColor"
                />
            </g>
        </svg>
    );
};

const EyeSymbol: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg viewBox="0 0 512 512" className={className}>
            <g>
                <g fill="#FFFFFF">
                    <path d="m34,256l26.2,26.2c108,108 283.7,108 391.7,0l26.1-26.2-26.2-26.2c-108-108-283.7-108-391.7,0l-26.1,26.2zm222,126.2c-75.8,0-151.6-28.9-209.3-86.6l-32.9-32.9c-3.7-3.7-3.7-9.7 0-13.5l32.9-32.9c115.4-115.4 303.2-115.4 418.6,0l32.9,32.9c3.7,3.7 3.7,9.7 0,13.5l-32.9,32.9c-57.7,57.7-133.5,86.6-209.3,86.6z" />
                    <path d="m256,183.5c-40,0-72.5,32.5-72.5,72.5s32.5,72.5 72.5,72.5c40,0 72.5-32.5 72.5-72.5s-32.5-72.5-72.5-72.5zm0,164c-50.5,0-91.5-41.1-91.5-91.5 0-50.5 41.1-91.5 91.5-91.5s91.5,41.1 91.5,91.5c0,50.5-41,91.5-91.5,91.5z" />
                </g>
            </g>
        </svg>
    );
};

const Plus: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className, fill }) => {
    const defaultFill = 'text-bnd-green';
    const usedFill = fill ? fill : defaultFill;
    return (
        <svg width="21" height="22" viewBox="0 0 21 22" fill="none" className={`fill-current ${usedFill} ${className}`}>
            <path d="M0.368958 12.8689H8.44249V21.69H12.2924V12.8689H20.3659V9.16852H12.2924V0.310059H8.44249V9.16852H0.368958V12.8689Z" />
        </svg>
    );
};

const Minus: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className, fill }) => {
    const defaultFill = 'text-bnd-green';
    const usedFill = fill ? fill : defaultFill;
    return (
        <svg width="20" height="4" viewBox="0 0 20 4" fill="none" className={`fill-current ${usedFill} ${className}`}>
            <path d="M0.00152588 3.85027H8.07506H11.9249H19.9985V0.149902H11.9249L8.07506 0.149965L0.00152588 0.149902V3.85027Z" />
        </svg>
    );
};

const SchommelChair: React.FC<{} & SVGProps<SVGSVGElement>> = ({ className }) => {
    return (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 24 24"
            className={className}
            xmlSpace="preserve"
        >
            <path
                fill="currentColor"
                d="M18.1,21.2c0.7-0.2,1.4-0.4,2.1-0.7c0.1-0.1,0.3-0.1,0.4-0.1c0.3,0,0.5,0.2,0.6,0.5s-0.1,0.6-0.4,0.7
	c-0.5,0.2-1,0.4-1.5,0.6c-1.5,0.4-3,0.7-4.5,0.8c-2.5,0.2-5,0-7.4-0.5C6,22.2,4.6,21.7,3.3,21c-0.4-0.2-0.8-0.5-1.1-0.8
	C1.9,20,1.8,19.6,2,19.3c0,0,0,0,0.1-0.1c0.1-0.2,0.6-0.2,0.8,0c0,0,0,0,0.1,0.1c0.5,0.4,1.1,0.8,1.8,1L5,20.4l2.2-6.8l-0.4-0.1
	c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0-0.1c0-0.4,0.4-0.6,0.7-0.6l0,0l4.9,0.5l4.1,0.4H16c0.1-0.6,0.1-1.1,0.2-1.7L16.9,5
	c0-0.4,0.3-0.7,0.6-0.7c0.4,0,0.7,0.3,0.7,0.6c0,0.1,0,0.1,0,0.2c-0.1,1.3-0.3,2.5-0.4,3.8c-0.3,2.6-0.5,5.2-0.8,7.7
	c0,0.2,0,0.5,0.1,0.7c0.4,1.1,0.7,2.3,1,3.5L18.1,21.2z M6.1,20.8c1.9,0.9,8.7,1.3,10.7,0.6c0-0.1,0-0.2-0.1-0.3c-0.3-1-0.6-2-0.9-3
	c0-0.2-0.2-0.4-0.4-0.3l-7.5-0.7c-0.6,0-0.6,0-0.7,0.5C6.8,18.6,6.5,19.7,6.1,20.8z M7.8,15.8h0.3L9.8,16l5.7,0.5
	c0.2,0,0.2,0,0.2-0.2c0-0.6,0.1-1.1,0.2-1.7v-0.2h-0.1L11,13.9l-2.3-0.2c-0.1,0-0.2-0.1-0.3,0.1C8.2,14.4,8,15.1,7.8,15.8L7.8,15.8z
	"
            />
            <path
                fill="currentColor"
                d="M15.4,6.2c0,2.9-2.3,5.2-5.2,5.2S5,9.1,5,6.2C5.1,3.3,7.4,1,10.2,1C13.1,1,15.4,3.3,15.4,6.2z M14.1,6.2
	c0-2.1-1.7-3.9-3.9-3.9S6.4,4,6.4,6.2c0,2.1,1.7,3.9,3.9,3.9C12.4,10,14.1,8.3,14.1,6.2L14.1,6.2z"
            />
            <g>
                <path
                    fill="currentColor"
                    d="M12,8.1c-0.3,0.3-0.8,0.5-1.4,0.5C9.5,8.6,8.6,8,8.3,7H7.6V6.4h0.5c0-0.1,0-0.2,0-0.2c0-0.1,0-0.1,0-0.2H7.6V5.2h0.7
		c0.3-1,1.3-1.6,2.3-1.6c0.5,0,0.9,0.1,1.2,0.3l-0.4,0.8c-0.2-0.2-0.5-0.2-0.9-0.2c-0.5,0-1,0.2-1.2,0.7h1.9l-0.3,0.7H9.1
		c0,0.1,0,0.2,0,0.2c0,0,0,0.1,0,0.2h1.6L10.4,7h-1c0.3,0.4,0.7,0.7,1.2,0.7c0.4,0,0.7-0.1,1-0.3L12,8.1z"
                />
            </g>
        </svg>
    );
};

const PensionSectionDoneIcon: React.FC<SVGProps<SVGElement>> = ({ className }) => {
    return (
        <svg
            width="25"
            height="25"
            viewBox="0 0 33 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M0 16.5C0 7.3873 7.3873 0 16.5 0C25.6127 0 33 7.3873 33 16.5C33 25.6127 25.6127 33 16.5 33C7.3873 33 0 25.6127 0 16.5Z"
                fill="#00B263"
            />
            <path
                d="M14.2543 17.4967L20.8498 10.6426C21.0328 10.4525 21.3355 10.4525 21.5185 10.6426L23.3627 12.5591C23.5458 12.7493 23.5458 13.0639 23.3627 13.254C20.4416 16.2897 17.5134 19.3254 14.5922 22.3683L14.5781 22.383L14.557 22.3976L14.55 22.4049L14.5289 22.4195L14.5077 22.4342L14.5007 22.4415L14.4937 22.4488L14.4866 22.4561L14.4796 22.4634L14.4725 22.4707L14.4655 22.4781L14.4585 22.4854L14.4514 22.4927H14.4444L14.4303 22.5H14.4162H14.4092H14.4022H14.3951H14.3881H14.381H14.374H14.367H14.3599H14.3529H14.3458H14.2755H14.2684H14.2614H14.2473H14.2403H14.2332C14.2262 22.5 14.2121 22.5 14.198 22.4927H14.184H14.1769H14.1628H14.1558L14.1347 22.4854L14.1206 22.4781H14.1136L14.1065 22.4707C14.0924 22.4634 14.0784 22.4561 14.0643 22.4488L14.0502 22.4415L14.0291 22.4268C14.0009 22.4049 13.9728 22.383 13.9446 22.361C6.20178 14.3147 16.3801 24.892 8.63726 16.8456C8.45425 16.6554 8.45425 16.3409 8.63726 16.1507L10.4815 14.2342C10.6645 14.044 10.9672 14.044 11.1502 14.2342L14.2543 17.4967Z"
                fill="white"
            />
        </svg>
    );
};

const Exclamationmark: React.FC<SVGProps<SVGElement>> = ({ className }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 301.691 301.691" className={className}>
            <g>
                <polygon points="119.151,0 129.6,218.406 172.06,218.406 182.54,0  " />
                <rect x="130.563" y="261.168" width="40.525" height="40.523" />
            </g>
        </svg>
    );
};

const ExclamationmarkRounded: React.FC<SVGProps<SVGElement>> = ({ className }) => {
    return (
        <svg
            width="79"
            height="274"
            viewBox="0 0 79 274"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M14.2225 234C14.2225 228.477 18.6996 224 24.2225 224H54.2225C59.7453 224 64.2225 228.477 64.2225 234V264C64.2225 269.523 59.7453 274 54.2225 274H24.2225C18.6996 274 14.2225 269.523 14.2225 264V234Z"
                fill="#333333"
            />
            <path
                d="M0.0285723 10.7479C-0.406519 4.94669 4.18305 0 10.0006 0H68.4444C74.2619 0 78.8515 4.94668 78.4164 10.7479L64.9164 190.748C64.525 195.966 60.1771 200 54.9444 200H23.5006C18.2678 200 13.9199 195.966 13.5286 190.748L0.0285723 10.7479Z"
                fill="#333333"
            />
        </svg>
    );
};

const SustainableIcon: React.FC<SVGProps<SVGElement>> = ({ className }) => {
    return (
        <svg
            id="Isolation_Mode"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 291.12 360.24"
            className={className}
            fill={'currentColor'}
        >
            <path d="m289.02,360.24c6.98-29.07-3.49-58.44-31.11-88.1,15.7-56.12,8.72-98.86-20.93-128.51C185.22,91.88,32.87,88.1,15.42,0c-56.41,204.69,48.56,376.82,206.43,322.73,4.36-1.16,26.17,4.07,34.6,15.41-6.98-31.4-170.96-71.52-203.24-207.31,73.85,147.41,240.74,152.64,235.8,229.4h0Z" />
        </svg>
    );
};

export const IconElements = {
    ArrowDown: ArrowDown,
    ArrowRising: ArrowRising,
    ArrowLeft: ArrowLeft,
    ArrowRight: ArrowRight,
    ChevronDown: ChevronDown,
    Banner: Banner,
    BarsUp: BarsUp,
    Calendar: Calendar,
    Clock: Clock,
    Coin: Coin,
    CopySheet: CopySheet,
    CustomSecurityShield: CustomSecurityShield,
    ErrorIcon: ErrorIcon,
    Exclamationmark,
    ExclamationmarkRounded,
    FamilyThick: FamilyThick,
    FamilyThin: FamilyThin,
    Globe: Globe,
    GrowingBars: GrowingBars,
    House: House,
    HouseOriginal: HouseOriginal,
    MoneyBag: MoneyBag,
    MoneyPig: MoneyPig,
    MoneyPile: MoneyPile,
    Plant: Plant,
    SecurityShield: SecurityShield,
    TimeAgenda: TimeAgenda,
    TimeDocument: TimeDocument,
    Tree: Tree,
    WalkStick: WalkStick,
    Check: Check,
    Cross: Cross,
    Calculator: Calculator,
    DoubleEndedArrow: DoubleEndedArrow,
    EyeSymbol: EyeSymbol,
    Plus: Plus,
    Minus: Minus,
    SchommelChair,
    PensionSectionDoneIcon: PensionSectionDoneIcon,
    SustainableIcon,
};
